import React from "react";
import {IconButton, Stack, Tooltip} from "@mui/material";
import {grey} from "@mui/material/colors";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowLeft01Icon, ArrowRight01Icon} from "@hugeicons/core-free-icons";
import {useDashboard} from "../../../../context/DashboardContext";
import {DEFAULT_RESPONSE_TIME_PERIOD, STATISTIC_PERIODS} from "../../../../repositories/DashboardRepository";

const navButtonSx = {
    pointerEvents: "auto",
    width: 24,
    height: 24,
    borderRadius: "50% !important",
    bgcolor: "#fff",
    color: grey[700],
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
    "&:hover": {bgcolor: grey[100]},
    "&.Mui-disabled": {bgcolor: "#fff", opacity: 0.4},
};

const stepLabel = (type, responseTimeWindows) => {
    const period = responseTimeWindows?.[type]?.period || DEFAULT_RESPONSE_TIME_PERIOD;
    const {step} = STATISTIC_PERIODS.find(p => p.value === period);
    return `${step.amount} ${step.unit}`;
};

// Left / right chevrons over a response-time chart; MiniCard shows them on hover
export const ResponseTimeNavigation = ({type}) => {
    const {responseTimeWindows, shiftResponseTime} = useDashboard();
    const isLive = !responseTimeWindows?.[type]?.end;
    const step = stepLabel(type, responseTimeWindows);

    return (
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}
               sx={{position: "absolute", inset: 0, px: 1.5, pointerEvents: "none"}}>
            <Tooltip title={`Back ${step}`}>
                <IconButton size={"small"} sx={navButtonSx} onClick={() => shiftResponseTime(type, -1)}>
                    <HugeiconsIcon icon={ArrowLeft01Icon} size={14}/>
                </IconButton>
            </Tooltip>
            <Tooltip title={isLive ? "Showing latest" : `Forward ${step}`}>
                <span style={{pointerEvents: "auto"}}>
                    <IconButton size={"small"} sx={navButtonSx} disabled={isLive}
                                onClick={() => shiftResponseTime(type, 1)}>
                        <HugeiconsIcon icon={ArrowRight01Icon} size={14}/>
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    );
};
